module.exports = __webpack_public_path__ + "media/images/athletes/1665-8e948e7d614faadb842d20aa9bc6499d.png";